import React, { useEffect, useMemo, useState } from 'react'
import { useRouter } from 'next/router'

import styled from '@emotion/styled'
import { getCookie } from 'cookies-next'

import { getFrontFaq } from 'api'
import Header from 'components/Header'
import Accordian from 'components/MypageSection/Accordian'
import { DEFAULT_LANG } from 'constants/lang'

const Faq = ({ initialData }) => {
  const router = useRouter()
  const lang = router.locale

  const [faqs, setFaqs] = useState(initialData)
  const { data, sys_type } = faqs

  const [filter, setFilter] = useState(null)
  const [openList, setOpenList] = useState([])

  const type = useMemo(() => {
    let arr = []
    for (let key in sys_type) {
      arr.push({
        name: sys_type[key],
        value: key,
      })
    }
    return arr
  }, [sys_type])

  const filterHandler = (type) => {
    if (filter === type) setFilter(null)
    else setFilter(type)
  }

  const toggleHandler = (id) => {
    let arr = openList.concat()
    const isIncludes = arr.includes(id)

    let newArr
    if (isIncludes) newArr = arr.filter((e) => e !== id)
    else newArr = [...arr, id]

    setOpenList(newArr)
  }

  // 언어 변경시 API 재호출
  const callGetFrontFaq = async () => {
    await getFrontFaq({ s_lang: lang }).then((res) => setFaqs(res))
  }

  const [didMount, setDidMount] = useState(false)
  useEffect(() => {
    if (!didMount) return
    callGetFrontFaq()
  }, [lang])

  useEffect(() => setDidMount(true), [])

  return (
    <>
      <Header title="FAQ" />
      <main>
        <FilterLists>
          {type.map((item) => (
            <li
              key={item.value}
              onClick={() => filterHandler(item.value)}
              style={{
                backgroundColor: filter === item.value ? '#ff4a52' : 'white',
                color: filter === item.value ? 'white' : 'black',
              }}
            >
              {item.name}
            </li>
          ))}
        </FilterLists>

        <Questions>
          {data.map((item) =>
            item.status === 'normal' && filter ? (
              item.type === filter && (
                <li onClick={() => toggleHandler(item.id)}>
                  <Accordian
                    label={`[${sys_type[item.type]}] ${
                      item.translate_question
                    }`}
                    content={item.translate_answer}
                    isOpened={openList.includes(item.id)}
                  />
                </li>
              )
            ) : (
              <li key={item.id} onClick={() => toggleHandler(item.id)}>
                <Accordian
                  label={`[${sys_type[item.type]}] ${item.translate_question}`}
                  content={item.translate_answer}
                  isOpened={openList.includes(item.id)}
                />
              </li>
            )
          )}
        </Questions>
      </main>
    </>
  )
}

export default Faq

export const getServerSideProps = async (ctx) => {
  const initialLang =
    ctx.locale === 'zh-cn' ? 'zh-Hans' : getCookie('lang', ctx) || DEFAULT_LANG
  const initialData = await getFrontFaq({ s_lang: initialLang }, 'server')

  return {
    props: {
      initialData,
    },
  }
}

const FilterLists = styled.ul`
  width: 100%;
  height: 48px;
  display: flex;
  margin-bottom: 16px;

  li {
    width: 20%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #e8e8e8;
    border-right: none;
    cursor: pointer;
  }
  li:last-of-type {
    border-right: 1px solid #e8e8e8;
  }
`

const Questions = styled.ul``
